"use client";

import { Button } from "@/components/ui/button";
import { primaryCourseContent } from "@/utils/misc/static-content";
import { useUser } from "@clerk/nextjs";
import Link from "next/link";
export default function DynamicCTAButton() {
  const {
    isLoaded,
    isSignedIn
  } = useUser();
  if (!isLoaded) {
    return <Button variant="secondary" className="w-36 cursor-default" />;
  }
  return <Button className="bg-landingPagePrimary text-darkGray hover:bg-landingPagePrimary hover:brightness-90" asChild data-sentry-element="Button" data-sentry-component="DynamicCTAButton" data-sentry-source-file="dynamic-cta-button.tsx">
      {isSignedIn ? <Link href="/student/dashboard">Go to dashboard</Link> : <Link href={`/course/${primaryCourseContent.slug}`}>Start learning today</Link>}
    </Button>;
}

// Recycled

{
  /* <OAuthSignInDialog>
      <Button className="bg-landingPagePrimary text-darkGray hover:bg-landingPagePrimary hover:brightness-90">
        Start learning today
      </Button>
    </OAuthSignInDialog> */
}

// return <div className="h-10 w-36 rounded-xl bg-muted" />;

// 29 Apr 2025

// const router = useRouter();
// const signInUrl = useSignInRedirectURL();

// onClick={() => router.push(signInUrl)}